import React from 'react';
import { 
  Info, 
  Phone, 
  Navigation,
  FileText,
  Camera,
  Settings
} from 'lucide-react';

export function OrderActions({
  hasNote,
  hasImages,
  hasStatus,
  onInfoClick,
  onContactClick,
  onDirectionsClick,
  onNoteClick,
  onCameraClick,
  onStatusClick
}) {
  const ActionButton = ({ icon: Icon, onClick, active }) => (
    <button
      onClick={onClick}
      className={`
        w-12 h-12 rounded-full shadow-lg transition-all
        flex items-center justify-center
        ${active 
          ? 'bg-brand-green text-white' 
          : 'bg-white text-gray-700 hover:bg-gray-50'
        }
        border-2 border-gray-900
      `}
    >
      <Icon className="w-5 h-5" />
    </button>
  );

  return (
    <>
      {/* Left Side Actions */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2 flex flex-col gap-3" style={{ zIndex: 1000 }}>
        <ActionButton 
          icon={Info} 
          onClick={onInfoClick}
        />
        <ActionButton 
          icon={Phone} 
          onClick={onContactClick}
        />
        <ActionButton 
          icon={Navigation} 
          onClick={onDirectionsClick}
        />
      </div>

      {/* Right Side Actions */}
      <div className="absolute right-4 top-1/2 -translate-y-1/2 flex flex-col gap-3" style={{ zIndex: 1000 }}>
        <ActionButton 
          icon={FileText} 
          onClick={onNoteClick}
          active={hasNote}
        />
        <ActionButton 
          icon={Camera} 
          onClick={onCameraClick}
          active={hasImages}
        />
        <ActionButton 
          icon={Settings} 
          onClick={onStatusClick}
          active={hasStatus}
        />
      </div>
    </>
  );
}